<template>
  <button
    :class="[
      bemBlock,
      'base-actionable-link',
      {
        'visually-hidden': visuallyHidden,
      },
    ]"
    :style="cssCustomProps"
    @click="$emit('actionable-link:clicked')"
  >
    <img
      v-if="buttonImage"
      :alt="$msg('actionable.link.img.alt', 'product', product.name)"
      :class="[
        bemElement('image'),
        {
          loading: loadingImage,
        },
      ]"
      :src="buttonImage"
      @error="handleImageError"
      @load="isImageLoaded"
    />
    <span v-if="buttonText" :class="bemElement('text')">
      {{ buttonText }}
    </span>
  </button>
</template>

<script>
import actionableLinkMixin from '../../mixins/actionableLinkMixin';
import bemClassesMixin from '../../mixins/bemClassesMixin';
import productPropColorMixin from '../../mixins/productPropColorMixin';
import sfraProductMixin from '../../mixins/sfraProductMixin';

const NO_IMAGE_PLACEHOLDER_COLOR = '#e0e0e0';
const NO_IMAGE_PLACEHOLDER = `<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8'><rect width='8' height='8' fill='${NO_IMAGE_PLACEHOLDER_COLOR}'/></svg>`;
const NO_IMAGE_PLACEHOLDER_URL = `data:image/svg+xml,${encodeURIComponent(NO_IMAGE_PLACEHOLDER)}`;
const NO_IMAGE = {
  alt: '',
  title: '',
  url: NO_IMAGE_PLACEHOLDER_URL,
};

export default {
  name: 'BaseProductActionableLink',

  mixins: [
    actionableLinkMixin,
    bemClassesMixin,
    productPropColorMixin,
    sfraProductMixin,
  ],

  props: {
    visuallyHidden: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    loadingImage: true,
  }),

  computed: {
    buttonText() {
      return this.actionableLinkButtonObject?.buttonText || '';
    },
    buttonImage() {
      return this.actionableLinkButtonObject?.image || null;
    },
    mobileBackgroundColor() {
      return this.actionableLinkButtonObject?.buttonColor || '';
    },
    desktopBackgroundColor() {
      return this.actionableLinkButtonObject?.buttonColorDesktop || '';
    },
    textColor() {
      return this.actionableLinkButtonObject?.buttonTextColor || '';
    },
    cssCustomProps() {
      return {
        '--button-background-color': this.mobileBackgroundColor,
        '--button-background-color-desktop': this.desktopBackgroundColor,
        '--button-text-color': this.textColor,
      };
    },
  },
  methods: {
    handleImageError(e) {
      const img = e.target;
      img.src = NO_IMAGE.url;
    },
    isImageLoaded() {
      this.loadingImage = false;
    },
  },
};
</script>
